export enum LoggedUserStatus {
  "Blocked" = "Blocked",
  "Waiting" = "Waiting",
  "Active" = "Active",
}
